import TableLoading from "../../../Components/Loader/TableLoading";
import MissionsGridCard from "./MissionsGridCard";

export default function MissionsGrid({
  rulesData,
  accountData,
  ruleLoading,
  missionStatuses,
}) {
  const {
    target,
    totalDrawdown,
    dailyDrawdown,
    tradeDrawdown,
    minTradingDays,
    consistencyRule,
    scalpProfit,
  } = missionStatuses;

  const isFunded = accountData?.phase?.phase_type === "funded";
  const isDemo = accountData?.challenge?.challenge_type === "demo";
  const rules = rulesData?.rules;

  const missions = [
    ...(!isFunded
      ? [
          {
            key: "profit-target",
            title: "سود هدف",
            current: rules?.profit_target?.current_state,
            goal: rules?.profit_target?.definition,
            status: target,
            type: "percent",
          },
        ]
      : []),
    {
      key: "max-drawdown",
      title: "حد ضرر کلی",
      current: rules?.max_drawdown_limit?.current_state,
      goal: rules?.max_drawdown_limit?.definition,
      status: totalDrawdown,
      type: "percent",
    },
    {
      key: "daily-drawdown",
      title: "حد ضرر روزانه",
      current: rules?.daily_drawdown_limit?.current_state,
      goal: rules?.daily_drawdown_limit?.definition,
      status: dailyDrawdown,
      type: "percent",
    },
    {
      key: "trade-drawdown",
      title: "حد ضرر هر معامله",
      current: rules?.trade_drawdown_limit?.current_state,
      goal: rules?.trade_drawdown_limit?.definition,
      status: tradeDrawdown,
      type: "percent",
    },
    ...(!isFunded && !isDemo
      ? [
          {
            key: "minimum-trading-days",
            title: "حداقل روزهای معاملاتی",
            current: rulesData?.trading_days,
            goal: rulesData?.min_trading_days,
            status: minTradingDays,
            type: "days",
          },
        ]
      : []),
    ...(rules?.consistency_rule?.definition != null
      ? [
          {
            key: "consistency-rule",
            title: "حداکثر سود هر روز معاملاتی از سود کل",
            current: rules.consistency_rule.current_state,
            goal: rules.consistency_rule.definition,
            status: consistencyRule,
            type: "percent",
          },
        ]
      : []),
    ...(rules?.fast_scalp?.definition != null
      ? [
          {
            key: "fast-scalp",
            title: "مجموع سود مجاز معاملات اسکلپ",
            current: rules.fast_scalp.current_state,
            goal: rules.fast_scalp.definition,
            status: scalpProfit,
            type: "percent",
          },
        ]
      : []),
  ];

  if (ruleLoading) {
    return (
      <div className="flex w-full items-center justify-center gap-2">
        <p className="text-[#808080]">در حال بارگذاری</p>
        <TableLoading className="text-[#808080]" />
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col gap-4 h-72 overflow-y-auto">
      {missions.map(({ key, ...mission }) => (
        <MissionsGridCard key={key} {...mission} />
      ))}
    </div>
  );
}
